import { Flex, Skeleton,  } from "@chakra-ui/react";

const CompaniesCardSkeleton = () => {
  return (
    <Flex direction={"column"} rowGap={"24px"}>
      <Flex direction={"column"} rowGap={"12px"} w={"100%"}>
        <Skeleton
          {...{ isLoaded: true }}
          w={"100%"}
          maxW={"100px"}
          bg={"#7E869E11"}
          borderRadius={"6px"}
          px={"8px"}
          py={"8px"}
        >
          <Skeleton borderRadius={"4px"} w={"100%"} maxW={"80px"} h={"24px"} />
        </Skeleton>
        <Skeleton
          {...{ isLoaded: true }}
          w={"100%"}
          maxW={"240px"}
          bg={"#7E869E11"}
          borderRadius={"6px"}
          px={"8px"}
          py={"8px"}
          alignSelf={"end"}
        >
          <Flex alignItems={"center"} w={"100%"} columnGap={"24px"}>
            <Skeleton
              borderRadius={"4px"}
              w={"100%"}
              maxW={"60px"}
              h={"24px"}
            />
            <Skeleton
              borderRadius={"4px"}
              w={"100%"}
              maxW={"40px"}
              h={"24px"}
            />
            <Flex align={"center"} w={"100%"} columnGap={"12px"}>
              <Skeleton borderRadius={"4px"} w={"24px"} h={"24px"} />
              <Skeleton borderRadius={"4px"} w={"24px"} h={"24px"} />
            </Flex>
          </Flex>
        </Skeleton>
      </Flex>
      {Array.from(Array(25).keys())?.map((sk) => (
        <Skeleton
          key={sk}
          {...{ isLoaded: true }}
          w={"100%"}
          bg={"#7E869E11"}
          borderRadius={"6px"}
          px={"20px"}
          py={"8px"}
        >
          <Flex direction={"column"} rowGap={"12px"}>
            <Flex alignItems={"center"} columnGap={"24px"}>
              <Skeleton
                borderRadius={"4px"}
                w={"100%"}
                maxW={"24px"}
                h={"24px"}
              />
              <Skeleton
                borderRadius={"4px"}
                w={"100%"}
                maxW={"100px"}
                h={"24px"}
              />
            </Flex>
            <Flex alignItems={"center"} columnGap={"12px"} w={"100%"}>
              <Skeleton
                borderRadius={"4px"}
                w={"100%"}
                maxW={"120px"}
                h={"32px"}
              />
            </Flex>
            <Flex
              align={"center"}
              columnGap={"12px"}
              rowGap={"12px"}
              justify={"space-between"}
            >
              <Flex direction={"column"} w={"100%"} rowGap={"8px"}>
                <Skeleton
                  borderRadius={"4px"}
                  w={"100%"}
                  maxW={"80px"}
                  h={"14px"}
                />
                <Skeleton
                  borderRadius={"4px"}
                  w={"100%"}
                  maxW={"100px"}
                  h={"16px"}
                />
              </Flex>
              <Flex direction={"column"} w={"100%"} rowGap={"8px"}>
                <Skeleton
                  borderRadius={"4px"}
                  w={"100%"}
                  maxW={"80px"}
                  h={"14px"}
                />
                <Skeleton
                  borderRadius={"4px"}
                  w={"100%"}
                  maxW={"100px"}
                  h={"16px"}
                />
              </Flex>
            </Flex>
            <Flex direction={"column"} w={"100%"} rowGap={"8px"}>
              <Skeleton
                borderRadius={"4px"}
                w={"100%"}
                maxW={"120px"}
                h={"14px"}
              />
              <Skeleton
                borderRadius={"4px"}
                w={"100%"}
                maxW={"140px"}
                h={"16px"}
              />
            </Flex>
          </Flex>
        </Skeleton>
      ))}
    </Flex>
  );
};

export default CompaniesCardSkeleton;
